// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"dbfd8592","396":"37563688","407":"97375fe8","534":"3acb31b2","599":"760ae31c","693":"9dc67fd5","722":"1cf136cd"}[chunkId] + ".chunk.css";
};